<template>
  <div ref="editor"></div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount,defineProps, defineEmits, watch } from "vue";

const props = defineProps<{
  placeholder?: string;
  modelValue?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

const editor = ref<HTMLElement | null>(null);
let quill: any = null;

onMounted(async () => {
  const Quill = (await import("quill")).default;
  import("quill/dist/quill.snow.css");

  if (editor.value) {
    quill = new Quill(editor.value, {
      theme: "snow",
      placeholder: props.placeholder || "Insert text here ...",
      modules: {
        toolbar: [
          [{ header: [1, 2, false] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          [{ color: [] }, { background: [] }], // <-- Add this
        ],
      },
    });

    if (props.modelValue) {
      //quill.root.innerHTML = props.modelValue;
      quill.clipboard.dangerouslyPasteHTML(props.modelValue || '');
    }

    editor.value.style.height = "200px";

    quill.on("text-change", () => {
      emit("update:modelValue", quill.root.innerHTML);
    });
  }
});

watch(
  () => props.modelValue,
  (newValue) => {
    if (quill && newValue !== quill.root.innerHTML) {
      quill.clipboard.dangerouslyPasteHTML(newValue || '');
    }
  }
);
onBeforeUnmount(() => {
  if (quill) {
    quill = null;
  }
});
</script>